import { render, staticRenderFns } from "./TopUpUsdtList.vue?vue&type=template&id=0aa1537d&scoped=true"
import script from "./TopUpUsdtList.vue?vue&type=script&lang=js"
export * from "./TopUpUsdtList.vue?vue&type=script&lang=js"
import style0 from "./TopUpUsdtList.vue?vue&type=style&index=0&id=0aa1537d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa1537d",
  null
  
)

export default component.exports